import moment from "moment";

export default {

  install(Vue, options) {

    moment.locale('en-gb');

    Vue.filter('msm_date', function (value) {
      if (!value) return '';

      return moment(value).format('L');
    });

    Vue.filter('msm_datetime', function (value) {
      if (!value) return '';

      return moment(value).format('L LT');
    });

    Vue.filter('msm_datetime_long', function (value) {
      if (!value) return '';

      return moment(value).format('LLL');
    });

    Vue.filter('msm_time', function (value) {
      if (!value) return '';

      return moment(value).format('LT');
    });

    Vue.filter('msm_year', function (value) {
      if (!value) return '';

      return moment(value).format('YYYY');
    });

    Vue.filter('msm_yearmonth', function (value) {
      if (!value) return '';

      return moment(value).format('YYYY-MM');
    });

    Vue.filter('msm_timefromnow', function (value) {
      if (!value) return '';

      return moment(value).fromNow();
    });

    Vue.filter('toOneDecimal', function (value) {
      if (!value && value !== 0) return '';

      return parseFloat(value).toFixed(1);
    });

    Vue.filter('tooltipDate', function(value){
      if (!value) return '';

      return new Date(value).toLocaleString('default', {month: 'short', year: 'numeric'})
    })
  }
}